import { debug } from 'zf-web-infra';
import { Base, Block, Box, useBreakpoint } from 'zf-web-components';
// import { customize } from '@customize';
import { useContext, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { RootContext } from '@stores';
import { useApp } from '@components';
import { Menu } from '../menu';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { SiderProps } from './types';

export function SiderComponent(props: SiderProps): ReactElement | null {
  debug.layout('Sider');

  const { token } = Base.theme.useToken();
  const rootContext = useContext(RootContext);
  const { md } = useBreakpoint();

  const { name, logo } = useApp();

  // 固定不显示菜单和头部
  if (rootContext.getIsHideMenuAndHeader() || props.show === false) {
    return null;
  }

  useEffect(() => {
    if (md === false) {
      rootContext.shared.setCollapsed(true);
    }
  }, [md, rootContext.shared]);

  // 小于752px 默认左侧菜单栏隐藏
  if (md === false && rootContext.shared.collapsed) {
    return null;
  }

  const navigateToHome = (): void => {
    window.location.assign('/');
  };

  return (
    <Base.Layout.Sider
      collapsible
      collapsed={rootContext.shared.collapsed}
      onCollapse={props.onCollapse}
      style={{ overflow: 'auto', height: '100vh', position: 'relative' }}
      trigger={null}
    >
      <Box className={styles.asideContent}>
        <Box className={styles.aside} onClick={navigateToHome}>
          {/* {customize.invoke('ajis.theme.image') ?? <img src={CONFIG.ENV.LOGO_WHITE} className={styles.logo} />} */}
          <img src={logo} className={styles.logo} />
          <Block if={!rootContext.shared.collapsed}>
            <span className={styles.label} style={{ color: token.colorPrimary }}>
              {name}
            </span>
          </Block>
        </Box>
        <Menu />
      </Box>
    </Base.Layout.Sider>
  );
}

export const Sider = observer(SiderComponent);
